import React from 'react';
import {faLocationArrow} from '@fortawesome/free-solid-svg-icons';

import Taylor from '../../../images/ProfileTaylor.jpg';
import Adrian from '../../../images/ProfileAdrian.jpg';
import Connor from '../../../images/ProfileConnor.jpg';
import Jared from '../../../images/ProfileJared.jpg';

import { 
    StyledContainer,  
    StyledGrid, 
    StyledGridItem, 
    StyledH2,
    StyledImg, 
    StyledIcon,
    StyledOverLay,
    StyledP, 
    StyledPaper, 
    StyledText, 
    TextWrapper,
    StyledFact
} from './OurTeam.style';


const OurTeam = () => {

    const teamMembers = [
        {name: 'Taylor LaMar', title: 'CEO', pic: Taylor, hiddenText: 'CEO'},
        {name: 'Connor Steele', title: 'Software Engineer', pic: Connor, hiddenText: `Software Engineer`},
        {name: 'Adrian Bernardo', title: 'Software Engineer', pic: Adrian, hiddenText: 'Software Engineer'},
        {name: 'Jarrod Granger', title: 'Intern', pic: Jared, hiddenText: 'Intern'},
    ]

    const renderGridItems = teamMembers.map(member => {
        return(
            <StyledGridItem item md={3} sm={6} xs={12}>
                <StyledPaper>
                    <StyledImg src={member.pic} alt={member.name}/> 
                    <TextWrapper>
                        <StyledText>
                            <br />
                            {member.name}<br />
                            {/* <StyledSpan>{member.title}</StyledSpan> */}
                        </StyledText> 
                        <StyledOverLay>
                            <StyledIcon className='icon' icon={faLocationArrow} aria-hidden="true"/>
                            <StyledFact className='hidden'>
                                {member.hiddenText}
                            </StyledFact>
                        </StyledOverLay>
                    </TextWrapper>  
                </StyledPaper>
            </StyledGridItem>
        )
    })
    
    return(
        <StyledContainer id='ourteam'>
            <StyledP>Meet Our Team</StyledP>
            <StyledH2>People that shape our success</StyledH2>
            <StyledGrid container spacing={3} justify='center'>
                {renderGridItems}
            </StyledGrid>
        </StyledContainer>    
    )
        
}

export default OurTeam;